export default __webpack_public_path__ + "static/media/703B0201.f4150007.jpg";